export const fmtCurrency = (v, decimals = 2) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(v || 0);

// Confidentiality: financial values arrive as null for restricted roles.
// Keep the unit visible without exposing a placeholder that looks like a value.
export const fmtCurrencyMasked = (v, decimals = 2) => (v == null ? "$" : fmtCurrency(v, decimals));

export const fmtCurrencyShort = (v) => {
  if (v == null) return "$0";
  if (Math.abs(v) >= 1000000) return `$${(v / 1000000).toFixed(1)}M`;
  if (Math.abs(v) >= 1000) return `$${(v / 1000).toFixed(0)}K`;
  return `$${Math.round(v)}`;
};

export const fmtNum = (v, decimals = 2) => {
  if (v == null || v === 0) return "-";
  const n = Number(v);
  return n % 1 === 0 ? String(n) : n.toFixed(decimals);
};

export const fmtMonth = (m) => {
  if (!m) return "";
  const [y, mo] = m.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(mo, 10) - 1]} ${y}`;
};

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    const match = String(d).match(/^(\d{4}-\d{2}-\d{2})/);
    const [y, m, day] = (match ? match[1] : String(d)).split("-");
    if (!y || !m || !day) return String(d);
    return `${m}/${day}/${y}`;
  } catch {
    return d;
  }
};
